module.exports = __webpack_public_path__ + "img/iphone.ba7def66.png";